import {useMutation} from "@apollo/client";
import pluralize from "pluralize";

import {FormModal} from "@/components/form/overlay/FormModal.tsx";
import {GQL_CHECKS_QUERY2, GQL_UPDATE_CONTACTS_STATE} from "@/lib/queries/checks.ts";
import {GraphQLResponse, ResponseStatus} from "@/lib/types/common.ts";
import {BulkSetContactsForm} from "@/pages/checks/list/actions/bulkSetContacts/BulkSetContactsForm.tsx";

export interface EditCheckContactsFormValues {
  contact_groups: number[];
}

export interface BulkSetContactsModalProps {
  selectedItemsIds: number[];
  show: boolean;
  setShow: (show: boolean) => void;
  onSuccess: () => void;
}

export const BulkSetContactsModal = ({selectedItemsIds, show, setShow, onSuccess}: BulkSetContactsModalProps) => {
  const [updateChecksContacts, {data, loading}] = useMutation<GraphQLResponse<null>>(GQL_UPDATE_CONTACTS_STATE, {
    refetchQueries: [GQL_CHECKS_QUERY2],
  });

  const handleSubmit = async (data: EditCheckContactsFormValues) => {
    const response = await updateChecksContacts({
      variables: {
        ids: selectedItemsIds,
        contact_groups: data.contact_groups,
      },
    });
    if (response.data?.response.status === ResponseStatus.SUCCESS) {
      setShow(false);
      onSuccess();
    }
  };

  const formId = "BulkSetContactsForm";
  return (
    <FormModal
      size="lg"
      disabled={loading}
      formId={formId}
      onCancel={() => setShow(false)}
      show={show}
      title={`Set Contacts on ${pluralize("Check", selectedItemsIds.length, true)}`}
    >
      <BulkSetContactsForm
        formId={formId}
        onSubmit={handleSubmit}
        serverErrors={data?.response?.status === ResponseStatus.ERROR ? data.response.message : undefined}
        onError={console.log}
      />
    </FormModal>
  );
};
